export default (state, action) => {

    switch(action.type){
        
      case "ANNOUNCEMENT_ID":
         return {
            ...state,
            announcementId: action.announcementId
         }

      case "ALL_GRADS":
         return {
            ...state,
            allGrads: action.allGrads
         }

      case "AUTHORIZED_TO_CRUD_ANNOUNCEMENTS":
         return {
            ...state,
            authorizedToCrudAnnouncements: action.authorizedToCrudAnnouncements
         }

      case "BIO_TBL_USER_DATA":
         return {
            ...state,
            bio_tbl_user_data: action.bio_tbl_user_data
         }

      case "CLASS_DATA":
         return {
            ...state,
            classData: action.classData
         }

         case "CLASS_PAGE":
         return {
            ...state,
            classPage: action.classPage
         }
 
      case "GOOD_LOGIN":
         return {
            ...state,
            goodLogin: action.goodLogin
         }

      case "HAS_BIO":
         return {
            ...state,
            hasBio: action.hasBio
         }

      case "ID_OF_STORY_TO_SHOW":
         return {
            ...state,
            idOfStoryToShow: action.idOfStoryToShow
         }

      case "IS_ACTIVE":
         return {
            ...state,
            isActive: action.isActive
         }

      case "IS_ADMIN":
         return {
            ...state,
            admin: action.admin
         }

      case "IS_ALUMNI":
         return {
            ...state,
            alumni: action.alumni
         }

      case "IS_SUPER_USER":
         return {
            ...state,
            superUser: action.superUser
         }

      case "STORE_JWT":
         return {
            ...state,
            jwt: action.jwt
         }

      case "LOGOUT":
         return {
            ...state,
            logout: action.logout
         }

      case "PHP_FILENAME":
         return {
            ...state,
            phpFileName: action.phpFileName
         }

      case "RESET_PASSWORD":
         return {
            ...state,
            resetPassword: action.resetPassword
         }

      case "SHOW_ALUMNI_BIO_NAVBAR_BUTTON":
         return {
            ...state,
            showAlumniBioNavbarButton: action.showAlumniBioNavbarButton
         }

      case "SHOW_CLASS_PAGE_NAVBAR_BUTTON":
         return {
            ...state,
            showClassPagesNavbarButton: action.showClassPagesNavbarButton
         }

      case "SHOW_HISTORY_NAVBAR_BUTTON":
         return {
            ...state,
            showHistoryNavbarButton: action.showHistoryNavbarButton
         }

         case "SHOW_HOME_NAVBAR_BUTTON":
         return {
            ...state,
            showHomeNavbarButton: action.showHomeNavbarButton
         }

      case "SHOW_MENU_NAVBAR_BUTTON":
         return {
            ...state,
            showMenuNavbarButton: action.showMenuNavbarButton
         }

      case "SIGNED_IN_USER_ID":
         return {
            ...state,
            signedInUserId: action.signedInUserId
         }

         case "SIGNED_IN_USERNAME":
         return {
            ...state,
            signedInUsername: action.signedInUsername
         }

      case "STORY":
         return {
            ...state,
            story: action.story
         }

      case "TPS_CLASS":
         return {
            ...state,
            tpsClass: action.tpsClass
         }

         case "UPDATE_AB_HONTS":
         return {
            ...state,
            classData: {...state.classData, "abHonts": action.abHonts}
         }

         case "UPDATE_C_DOT":
         return {
            ...state,
            classData: {...state.classData, "cDot": action.cDot}
         }

         case "UPDATE_CLASS_LEADER":
         return {
            ...state,
            classData: {...state.classData, "classLeader": action.classLeader}
         }

         case "UPDATE_DISTINGUISHED_ALUMNUS":
         return {
            ...state,
            classData: {...state.classData, "distinguishedAlumnus": action.distinguishedAlumnus}
         }

         case "UPDATE_LIETHEN_TITTLE":
         return {
            ...state,
            classData: {...state.classData, "liethenTittle": action.liethenTittle}
         }

         case "UPDATE_ONIZUKA_PROP_WASH":
         return {
            ...state,
            classData: {...state.classData, "onizukaPropWash": action.onizukaPropWash}
         }

         case "UPDATE_OUTSTANDING_FTE":
         return {
            ...state,
            classData: {...state.classData, "outstandingFTE": action.outstandingFTE}
         }

         case "UPDATE_PROP_WASH":
         return {
            ...state,
            classData: {...state.classData, "propWash": action.propWash}
         }

         case "UPDATE_RAYMOND_JONES":
         return {
            ...state,
            classData: {...state.classData, "raymondJones": action.raymondJones}
         }

      case "USER_ID":
         return {
            ...state,
            userId: action.userId
         }

      case "USER_ID_OF_BIO_TO_ADD":
      return {
         ...state,
         userIdOfBioToAdd: action.userIdOfBioToAdd
      }

      case "USER_ID_OF_BIO_TO_EDIT":
      return {
         ...state,
         userIdOfBioToEdit: action.userIdOfBioToEdit
      }

      case "USER_ID_OF_BIO_TO_SHOW":
      return {
         ...state,
         userIdOfBioToShow: action.userIdOfBioToShow
      }

      case "USER_ID_OF_PROFILE_TO_EDIT":
         return {
            ...state,
            userIdOfProfileToEdit: action.userIdOfProfileToEdit
      }

      case "USER_ID_OF_STORY_TO_ADD":
         return {
            ...state,
            userIdOfStoryToAdd: action.userIdOfStoryToAdd
         }

      case "USERID_AUTHORIZED_TO_CRUD_WEEKLY_UPDATE":
      return {
         ...state,
         userIdAuthorizedToCrudWeeklyUpdate: action.userIdAuthorizedToCrudWeeklyUpdate
      }
      
      case "USERNAME":
         return {
            ...state,
            username: action.username
         }

      case "USER_TYPE":
         return {
            ...state,
            userType: action.userType
         }

      default:
      return state
    }
 }